import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _observers, _mutationCache, _retryer, _dispatch;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/mutation.ts
import { notifyManager } from "./notifyManager.js";
import { Removable } from "./removable.js";
import { createRetryer } from "./retryer.js";
var Mutation = (_observers = /*#__PURE__*/new WeakMap(), _mutationCache = /*#__PURE__*/new WeakMap(), _retryer = /*#__PURE__*/new WeakMap(), _dispatch = /*#__PURE__*/new WeakSet(), class Mutation extends Removable {
  constructor(config) {
    super();
    _classPrivateMethodInitSpec(this, _dispatch);
    _classPrivateFieldInitSpec(this, _observers, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _mutationCache, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _retryer, {
      writable: true,
      value: void 0
    });
    this.mutationId = config.mutationId;
    _classPrivateFieldSet(this, _mutationCache, config.mutationCache);
    _classPrivateFieldSet(this, _observers, []);
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = options;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!_classPrivateFieldGet(this, _observers).includes(observer)) {
      _classPrivateFieldGet(this, _observers).push(observer);
      this.clearGcTimeout();
      _classPrivateFieldGet(this, _mutationCache).notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    _classPrivateFieldSet(this, _observers, _classPrivateFieldGet(this, _observers).filter(x => x !== observer));
    this.scheduleGc();
    _classPrivateFieldGet(this, _mutationCache).notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!_classPrivateFieldGet(this, _observers).length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        _classPrivateFieldGet(this, _mutationCache).remove(this);
      }
    }
  }
  continue() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3;
    return (_classPrivateFieldGet2 = (_classPrivateFieldGet3 = _classPrivateFieldGet(this, _retryer)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.continue()) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 :
    // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(variables) {
    var _this$options$retry;
    const onContinue = () => {
      _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
        type: "continue"
      });
    };
    _classPrivateFieldSet(this, _retryer, createRetryer({
      fn: () => {
        if (!this.options.mutationFn) {
          return Promise.reject(new Error("No mutationFn found"));
        }
        return this.options.mutationFn(variables);
      },
      onFail: (failureCount, error) => {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "failed",
          failureCount,
          error
        });
      },
      onPause: () => {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "pause"
        });
      },
      onContinue,
      retry: (_this$options$retry = this.options.retry) !== null && _this$options$retry !== void 0 ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => _classPrivateFieldGet(this, _mutationCache).canRun(this)
    }));
    const restored = this.state.status === "pending";
    const isPaused = !_classPrivateFieldGet(this, _retryer).canStart();
    try {
      var _classPrivateFieldGet6, _classPrivateFieldGet7, _this$options$onSucce, _this$options2, _classPrivateFieldGet8, _classPrivateFieldGet9, _this$options$onSettl, _this$options3;
      if (restored) {
        onContinue();
      } else {
        var _classPrivateFieldGet4, _classPrivateFieldGet5, _this$options$onMutat, _this$options;
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "pending",
          variables,
          isPaused
        });
        await ((_classPrivateFieldGet4 = (_classPrivateFieldGet5 = _classPrivateFieldGet(this, _mutationCache).config).onMutate) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.call(_classPrivateFieldGet5, variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables));
        if (context !== this.state.context) {
          _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
            type: "pending",
            context,
            variables,
            isPaused
          });
        }
      }
      const data = await _classPrivateFieldGet(this, _retryer).start();
      await ((_classPrivateFieldGet6 = (_classPrivateFieldGet7 = _classPrivateFieldGet(this, _mutationCache).config).onSuccess) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.call(_classPrivateFieldGet7, data, variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context));
      await ((_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(this, _mutationCache).config).onSettled) === null || _classPrivateFieldGet8 === void 0 ? void 0 : _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, null, this.state.variables, this.state.context, this));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context));
      _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
        type: "success",
        data
      });
      return data;
    } catch (error) {
      try {
        var _classPrivateFieldGet0, _classPrivateFieldGet1, _this$options$onError, _this$options4, _classPrivateFieldGet10, _classPrivateFieldGet11, _this$options$onSettl2, _this$options5;
        await ((_classPrivateFieldGet0 = (_classPrivateFieldGet1 = _classPrivateFieldGet(this, _mutationCache).config).onError) === null || _classPrivateFieldGet0 === void 0 ? void 0 : _classPrivateFieldGet0.call(_classPrivateFieldGet1, error, variables, this.state.context, this));
        await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context));
        await ((_classPrivateFieldGet10 = (_classPrivateFieldGet11 = _classPrivateFieldGet(this, _mutationCache).config).onSettled) === null || _classPrivateFieldGet10 === void 0 ? void 0 : _classPrivateFieldGet10.call(_classPrivateFieldGet11, void 0, error, this.state.variables, this.state.context, this));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context));
        throw error;
      } finally {
        _classPrivateMethodGet(this, _dispatch, _dispatch2).call(this, {
          type: "error",
          error
        });
      }
    } finally {
      _classPrivateFieldGet(this, _mutationCache).runNext(this);
    }
  }
});
function _dispatch2(action) {
  const reducer = state => {
    switch (action.type) {
      case "failed":
        return _objectSpread(_objectSpread({}, state), {}, {
          failureCount: action.failureCount,
          failureReason: action.error
        });
      case "pause":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: true
        });
      case "continue":
        return _objectSpread(_objectSpread({}, state), {}, {
          isPaused: false
        });
      case "pending":
        return _objectSpread(_objectSpread({}, state), {}, {
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        });
      case "success":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        });
      case "error":
        return _objectSpread(_objectSpread({}, state), {}, {
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        });
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    _classPrivateFieldGet(this, _observers).forEach(observer => {
      observer.onMutationUpdate(action);
    });
    _classPrivateFieldGet(this, _mutationCache).notify({
      mutation: this,
      type: "updated",
      action
    });
  });
}
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
export { Mutation, getDefaultState };